import React from 'react';
import DocumentTitle from 'components/TopLevel/DocumentTitle';

import Config from 'Config'
import { Spinner } from 'components/Elements/Loading'

class SignOut extends React.Component {
  render() {
    const signInUrl = Config.ioSignInUrl

    return (
      <div className="landing" >
        <DocumentTitle title="Signing out of Adafruit IO" />
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h1>Signing Out</h1>
              <p><a href={signInUrl}>Sign back in</a></p>
              <Spinner />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SignOut
